import { useCallback, useEffect } from 'react'

import { useAppSelector } from 'common/hooks/redux'
import useWebsockets from 'common/hooks/useWebsockets'

const useNewLanguageWebsocketSubscription = () => {
  const { isConnectionReady, sendJsonMessage } = useWebsockets()

  const accountId = useAppSelector((state) => state.authStates.accountId)
  const wsTopic = `accounts/${accountId}/new_language`

  const handleUnload = useCallback(() => {
    if (wsTopic) {
      sendJsonMessage({ action: 'unsubscribe', topics: [wsTopic] })
    }
  }, [sendJsonMessage, wsTopic])

  useEffect(() => {
    if (isConnectionReady) {
      sendJsonMessage({ action: 'subscribe', topics: [wsTopic] })
    }

    window.addEventListener('beforeunload', handleUnload)

    return () => {
      sendJsonMessage({ action: 'unsubscribe', topics: [wsTopic] })
    }
  }, [isConnectionReady, sendJsonMessage, wsTopic, handleUnload])
}

export default useNewLanguageWebsocketSubscription
